<template>
  <div class="card">
    <div class="card-header">
      Istatistik
    </div>
    <DateFilter :startDate="startDate" :endDate="endDate" v-on:data-change="updateDate"></DateFilter>
    <div class="card-block p-0">
      <div class="table-responsive">
        <table class="table mb-0">
          <tbody>
          <tr v-if="session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_admin }}</th>
            <td>{{ stats.disabledAdmin + stats.activeAdmin }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_active_admin }}</th>
            <td>{{ stats.activeAdmin }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_passive_admin }}</th>
            <td>{{ stats.disabledAdmin }}</td>
          </tr>
          <tr v-if="session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_reseller }}</th>
            <td>{{ stats.disabledReseller + stats.activeReseller }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_active_reseller }}</th>
            <td>{{ stats.activeReseller }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_passive_reseller }}</th>
            <td>{{ stats.disabledReseller }}</td>
          </tr>
          <tr v-if="!session.roles.includes('ROLE_CREATE_SUB_RESELLER')">
            <th class="text-xs-right">{{ t.custom_reseller_panel.total_reseller }}</th>
            <td>{{ stats.disabledAdmin + stats.activeAdmin }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_active_reseller }}</th>
            <td>{{ stats.activeAdmin }}</td>
            <th class="text-xs-right">{{  t.custom_reseller_panel.total_passive_reseller }}</th>
            <td>{{ stats.disabledAdmin }}</td>
          </tr>
          <tr>
            <th class="text-xs-right">{{ t.custom_reseller_panel.total_card}}</th>
            <td>{{ stats.cards }}</td>
            <th class="text-xs-right"></th>
            <td></td>
            <th class="text-xs-right"></th>
            <td></td>
          </tr>
          <tr>
            <th class="text-xs-right">{{ t.total_card_balance }}</th>
            <td><code>{{ balance.card_balance }}</code></td>
            <th class="text-xs-right">{{ t.total_reseller_giro }}</th>
            <td>{{ balance.bet_balance }}</td>
            <th class="text-xs-right"></th>
            <td></td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DateFilter from "../DateFilter";
import Loading from "../Loading";
import AdminGiroRow from "../row/AdminGiroRow";
export default {
  name: "AdminStats",
  components: {Loading, DateFilter, AdminGiroRow},
  data() {
    return {
      session: window.session,
      startDate: moment().startOf('week').add(1, 'days').format("DD MMMM YYYY ddd"),
      endDate: moment().format("DD MMMM YYYY ddd"),
      data: [],
      loading: false,
      t: this.$root.t,
      totalBetProfit: 0,
      totalCasinoProfit: 0,
      balance: {},
      stats: {}
    }
  },
  watch: {
    'startDate' () {
      this.fetchBalance()
    }
  },
  mounted() {
    this.fetchStats();
    this.fetchBalance()
  },
  methods: {
    updateDate (e) {
    },
    fetchStats() {
      this.$http.get(api + 'api/v1/ba/stats').then(response => {
          this.stats = response.body.result
      })
    },
    fetchReport() {
      this.$http.get(api + 'api/v1/ba/stats').then(response => {
        this.stats = response.body.result
      })
    },
    fetchBalance(){
          this.$http.get(api + 'api/v1/reseller_giro/'+this.session.uid, {
            params: {
              start: moment(this.startDate, 'DD MMMM YYYY ddd').format("YYYY-MM-DD"),
              end: moment(this.endDate, 'DD MMMM YYYY ddd').format("YYYY-MM-DD")
            }
          })
          .then(response => {
            this.balance = response.body.result.data;

          }, response => {

          })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/AdminStats.vue